<template>
  <v-card>
    <v-card-text>
      <h3>Cooking</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'cup [US]',
          val: 1
        },
        {
          text: 'dash',
          val: 383.9999999956
        },
        {
          text: 'dessertspoon [US]',
          val: 24.00000000106
        },
        {
          text: 'dessertspoon [UK]',
          val: 19.98417216308
        },
        {
          text: 'dram[US fluid]',
          val: 64
        },
        {
          text: 'dram[UK fluid]',
          val: 66.61393477032
        },
        {
          text: 'drop',
          val: 4607.999999938
        },
        {
          text: 'fifth',
          val: 0.3125
        },
        {
          text: 'fluid ounce [US fluid, fl oz]',
          val: 8
        },
        {
          text: 'fluid ounce [UK fluid, fl oz]',
          val: 8.32674184629
        },
        {
          text: 'gallon [US, fluid]',
          val: 0.0625
        },
        {
          text: 'gallon [US, dry]',
          val: 0.05371013825974
        },
        {
          text: 'gallon [UK]',
          val: 0.05204213653931
        },
        {
          text: 'gill [US]',
          val: 2
        },
        {
          text: 'gill [UK]',
          val: 1.665348369258
        },
        {
          text: 'liter',
          val: 0.2365882365
        },
        {
          text: 'milliliter',
          val: 236.5882365
        },
        {
          text: 'pint [US, fluid]',
          val: 0.5
        },
        {
          text: 'pint [US, dry]',
          val: 0.4296811060779
        },
        {
          text: 'pint [UK]',
          val: 0.4163370923145
        },
        {
          text: 'quart [US, fluid]',
          val: 0.25
        },
        {
          text: 'quart [US, dry]',
          val: 0.214840553039
        },
        {
          text: 'quart [UK]',
          val: 0.2081685461572
        },
        {
          text: 'tablepoon [US]',
          val: 16
        },
        {
          text: 'tablepoon [Food and Drug Administration]',
          val: 15.7725491
        },
        {
          text: 'teaspoon [US]',
          val: 48
        },
        {
          text: 'teaspoon [Food and Drug Administration]',
          val: 47.3176473
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// cooking.vue?a17e2bfc